import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/shootTJ",
    name: "shootTJ",
    component: dashboard,
    redirect: {
      name: "timeTJ"
    },
    children: [
      {
        path: "timeTJ",
        name: "timeTJ",
        meta: { title: "时间维度统计" },
        component: () => import("@/views/shootTJ/timeTJ/timeTJ.vue"),
        children: []
      },
      {
        path: "areaTj",
        name: "areaTj",
        meta: { title: "空间维度统计" },
        component: () => import("@/views/shootTJ/areaTj/areaTj.vue"),
        children: []
      },
      {
        path: "productTj",
        name: "productTj",
        meta: { title: "品牌产品维度统计" },
        component: () => import("@/views/shootTJ/productTj/productTj.vue"),
        children: []
      },
      {
        path: "timeAndAreaTj",
        name: "timeAndAreaTj",
        meta: { title: "时间和空间维度统计" },
        component: () =>
          import("@/views/shootTJ/timeAndAreaTj/timeAndAreaTj.vue"),
        children: []
      },
      {
        path: "timeAndProductTj",
        name: "timeAndProductTj",
        meta: { title: "时间和品牌产品维度统计" },
        component: () =>
          import("@/views/shootTJ/timeAndProductTj/timeAndProductTj.vue"),
        children: []
      },
      {
        path: "areaAndProductTj",
        name: "areaAndProductTj",
        meta: { title: "空间和品牌产品维度统计" },
        component: () =>
          import("@/views/shootTJ/areaAndProductTj/areaAndProductTj.vue"),
        children: []
      }
    ]
  }
];
